import React from 'react'
import PropTypes from 'prop-types'
import USER_SETTINGS from 'constants/userSettings'
import { MSF } from 'components/SwitchAndGauge/definitions/dashConstants'

import { useSelector, useMakeSelector } from 'hooks/redux'
import { getUserSetting } from 'selectors/user'
import { getLocationType, makeDisablePartNumber } from 'selectors/dash'

import PartNumber from './PartNumberView'

// PBI 479416: keep MSF artwork inside its database-sized location on the dash.
const PartGraphic = ({
  location,
  Part,
  selected,
  detail,
  dashboardType,
  dimensions,
  panel,
  imageUrls = [],
  preferLocationShape,
}) => {
  const showPartNumbers = useSelector(
    getUserSetting,
    USER_SETTINGS.SWITCH_AND_GAUGE_SHOW_PART_NUMBERS
  )
  const noShowPartNumber = useMakeSelector(makeDisablePartNumber, location)
  const locationType = useSelector(getLocationType, location)

  const canShowPartNumber = showPartNumbers && !noShowPartNumber

  if (!Part) return null

  if (canShowPartNumber) {
    return <PartNumber location={location} selected={selected} />
  }
  const renderPart = (imageUrl) => (
    <Part
      location={location}
      detail={detail}
      dashboardType={dashboardType}
      panel={panel}
      selected={selected}
      style={{
        width: '100%',
        // PBI 479416: MSF SVG viewBoxes can exceed the location height.
        height: preferLocationShape || locationType === MSF ? '100%' : 'auto',
      }}
      dimensions={dimensions}
      imageUrl={imageUrl}
    />
  )
  if (imageUrls?.length === 0) {
    return renderPart(undefined)
  } else {
    return imageUrls.map((imageUrl, index) => (
      <div
        key={imageUrl || index}
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
        }}
      >
        {renderPart(imageUrl)}
      </div>
    ))
  }
}

PartGraphic.propTypes = {
  location: PropTypes.string,
  Part: PropTypes.elementType,
  selected: PropTypes.bool,
  detail: PropTypes.string,
  dashboardType: PropTypes.string,
  dimensions: PropTypes.object,
  panel: PropTypes.string,
  imageUrls: PropTypes.arrayOf(PropTypes.string),
  preferLocationShape: PropTypes.bool,
}

export default PartGraphic
